import { Tab, Tabs } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router";

export type AiTab = "ai_chats" | "profile_generation" | "tests";

function AITab() {
  const navigate = useNavigate();
  const location = useLocation();

  const tab = location.pathname.split("/")[4] as AiTab;

  const goToTab = (tab: AiTab) => {
    navigate(tab);
  };

  return (
    <div>
      <Tabs value={tab} onChange={(_evt, v) => goToTab(v)}>
        <Tab value="profile-generation" label="Profile Generation" iconPosition="start" />
        <Tab value="chats" label="Chats" iconPosition="start" />
        <Tab value="tests" label="Tests" iconPosition="start" />
      </Tabs>
      <div className="flex flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}

export default AITab;
